import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { WebsiteOrder } from 'shared/build/types';
import { useQuery } from 'react-query';
import { customFetch } from '../util/functions';
import { toast } from 'react-toastify';
import { FullscreenSpinner } from '../components/FullscreenSpinner';
import { ItemsTable } from '../components/ItemsTable';
import { Money } from 'shared/build/Money';
import { OrderStatus } from 'shared/build/enums';
import { NamedColorsHEX } from '../util/styles';

const ScWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ScOrder = styled.div`
  h6 {
    span {
      font-size: 70%;
      margin-left: 20px;
    }

    span.cancelled {
      color: ${NamedColorsHEX.PantoneTrueRed};
    }

    span.expand {
      cursor: pointer;
    }
  }
`;

export const Orders = () => {
  const [enhancedOrders, setEnhancedOrders] = useState<
    Array<WebsiteOrder & { show: boolean }>
  >([]);

  const { data: websiteOrders, status } = useQuery<WebsiteOrder[], string>(
    'website-orders',
    async (): Promise<WebsiteOrder[]> => {
      const response = await customFetch(`/api/website/orders`);
      if (response.ok) {
        const items = await response.json();
        return items.map((it: WebsiteOrder) => {
          return {
            ...it,
            purchasedAt: new Date(it.purchasedAt),
            cancelledAt: it.cancelledAt
              ? new Date(it.cancelledAt)
              : it.cancelledAt,
          };
        });
      }

      toast.error('Ocorreu um erro ao carregar os presentes.');
      throw new Error(response.toString());
    }
  );

  useEffect(() => {
    setEnhancedOrders(
      (websiteOrders || []).map((order) => ({
        ...order,
        show: false,
      }))
    );
  }, [websiteOrders]);

  if (!websiteOrders || status === 'loading') {
    return (
      <ScWrapper className="babys-page-padding">
        <FullscreenSpinner show={status === 'loading' || !websiteOrders} />
      </ScWrapper>
    );
  }

  return (
    <ScWrapper className="babys-page-padding">
      {enhancedOrders
        .sort((a, b) => {
          if (a.purchasedAt < b.purchasedAt) return 1;

          if (a.purchasedAt > b.purchasedAt) return -1;

          return 0;
        })
        .map((order, i) => {
          return (
            <ScOrder key={order.id}>
              <h6
                onClick={() => {
                  setEnhancedOrders([
                    ...enhancedOrders.slice(0, i),
                    { ...order, show: !order.show },
                    ...enhancedOrders.slice(i + 1),
                  ]);
                }}
              >
                {order.items.length === 1
                  ? 'Presente ofertado'
                  : 'Presentes ofertados'}{' '}
                em {order.purchasedAt.toLocaleString()}
                <span className="expand">
                  {order.show ? 'Reduzir' : 'Expandir'}
                </span>
                <span className="cancelled">
                  {order.status === OrderStatus.Cancelled && 'Cancelado'}
                </span>
              </h6>
              {order.show && (
                <ItemsTable
                  currency={order.currency}
                  items={order.items.map((it) => {
                    return {
                      ...it,
                      unitPrice: new Money(it.unitPrice, order.currency),
                    };
                  })}
                />
              )}
            </ScOrder>
          );
        })}
    </ScWrapper>
  );
};
